import { useState, useEffect } from 'react'
import i18n from '../../../i18n'
import { bruktbilfinansieringAPI } from '../../../services/api'
import type { DealersResponse } from '../../../types/bruktbilfinansiering'
import type { BruktbilfinansieringFilters } from './useBruktbilfinansiering'

export function useDealers(
  bankOrgNr: string,
  filters: BruktbilfinansieringFilters,
  sortBy: string,
  sortDir: 'asc' | 'desc'
) {
  const [data, setData] = useState<DealersResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = async () => {
    setLoading(true)
    setError(null)
    try {
      // Pass classes when a buyer-type filter is active (subset of scope=1 classes);
      // when all buyer types are selected the parent omits classes entirely (backward compat).
      const res = await bruktbilfinansieringAPI.getDealers(bankOrgNr, {
        start_date: filters.startDate,
        end_date: filters.endDate,
        dealer_postnummer: filters.dealerPostnummer ?? undefined,
        buyer_postnummer: filters.buyerPostnummer ?? undefined,
        varebil: filters.varebil,
        sort_by: sortBy,
        sort_dir: sortDir,
        classes: filters.classes,
      })
      setData(res.data)
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : i18n.t('errors.unknown', { ns: 'bbf' })
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refetch()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankOrgNr, filters.startDate, filters.endDate, filters.dealerPostnummer, filters.buyerPostnummer, filters.varebil, JSON.stringify(filters.classes), sortBy, sortDir])

  return { data, loading, error, refetch }
}
